<template>
  <img
    :src="block.data.url"
    :alt="block.data.name"
  >
</template>

<script>
export default {
  name: 'MoleculeContentNodeBlockImage',

  props: {
    block: Object
  }
}
</script>
